import { module as modujs } from "modujs";

import Flickity from "flickity";

import "flickity-fade";
import "flickity-as-nav-for";

export default class extends modujs {
	constructor(m) {
		super(m);

		this._previousHandlers = new Map();
		this._nextHandlers = new Map();
	}

	init() {
		this.flkty = new Flickity(this.el, JSON.parse(this.getData("config")));
		this.flkty.resize();

		this.id = this.el.getAttribute("data-module-flickity");

		this.$prevBtns = document.querySelectorAll('.o-carousel_actions[data-flickity-for="' + this.id + '"] .o-carousel_btn.-prev');
		this.$progressBar = document.querySelector('.o-carousel_actions[data-flickity-for="' + this.id + '"] .o-carousel_progress');

		this.$prevBtns.forEach((element) => {
			let _previousHandler = this.previous.bind(this);
			this._previousHandlers.set(element, _previousHandler);
			element.addEventListener("click", _previousHandler);
		});

		this.$nextBtns = document.querySelectorAll('.o-carousel_actions[data-flickity-for="' + this.id + '"] .o-carousel_btn.-next');

		this.$nextBtns.forEach((element) => {
			let _nextHandler = this.next.bind(this);
			this._nextHandlers.set(element, _nextHandler);
			element.addEventListener("click", _nextHandler);
		});

		this.flkty.on("staticClick", (event, pointer, cellElement, cellIndex) => this.select(event, pointer, cellElement, cellIndex));

		this.flkty.on("change", (index) => this.change(index));

		this.flkty.on("dragStart", () => (this.flkty.slider.style.pointerEvents = "none"));
		this.flkty.on("dragEnd", () => (this.flkty.slider.style.pointerEvents = "auto"));

		this.change(this.flkty.selectedIndex);
		this.updateProgress();
	}

	select(event, pointer, cellElement, cellIndex) {
		this.flkty.select(cellIndex, false, false);
	}

	change(index) {
		if (!this.flkty.options.wrapAround) {
			this.$nextBtns.forEach(($button) => {
				$button.classList.remove("is-disabled");
			});
			this.$prevBtns.forEach(($button) => {
				$button.classList.remove("is-disabled");
			});

			if (index == 0) {
				this.$prevBtns.forEach(($button) => {
					$button.classList.add("is-disabled");
				});
			} else if (this.flkty.slides.length - 1 == index) {
				this.$nextBtns.forEach(($button) => {
					$button.classList.add("is-disabled");
				});
			}
		}
		this.updateProgress();
	}

	updateProgress() {
		if (this.$progressBar) {
			const totalSlides = this.flkty.slides.length;
			const currentIndex = this.flkty.selectedIndex;
			const progress = ((currentIndex + 1) / totalSlides) * 100;
			this.$progressBar.style.setProperty("--progress-width", `${progress}%`);
		}
	}

	previous() {
		this.flkty.previous();
		this.flkty.stopPlayer();
	}

	next() {
		this.flkty.next();
		this.flkty.stopPlayer();
	}

	destroy() {
		this.flkty.destroy();

		this._previousHandlers.forEach((handler, element) => {
			element.removeEventListener("click", handler);
		});
		this._previousHandlers.clear();

		this._nextHandlers.forEach((handler, element) => {
			element.removeEventListener("click", handler);
		});
		this._nextHandlers.clear();
	}
}
